module.exports = __webpack_public_path__ + "img/yhgh4.e5297be8.png";